import type { ReactNode } from "react";

type BrowserFrameProps = {
  children: ReactNode;
  className?: string;
};

export default function BrowserFrame({ children, className = "" }: BrowserFrameProps) {
  return (
    <div className={`overflow-hidden rounded-lg border border-navy-100 bg-white ${className}`}>
      <div className="flex items-center gap-2 border-b border-navy-100 bg-navy-50/70 px-3 py-2.5">
        <span className="flex gap-1.5" aria-hidden="true">
          <span className="h-2.5 w-2.5 rounded-full bg-navy-200" />
          <span className="h-2.5 w-2.5 rounded-full bg-navy-200" />
          <span className="h-2.5 w-2.5 rounded-full bg-lime-400" />
        </span>
        <span className="h-5 flex-1 rounded-md bg-white/70" aria-hidden="true" />
      </div>
      {children}
    </div>
  );
}